var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAspectRatio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "15px",
    viewBox: "0 0 23 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-aspect-ratio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-354.000000, -225.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-aspect-ratio",
    transform: "translate(354.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L0.5,14.5 L15.5,14.5 L15.5,0.5 L0.5,0.5 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.5,
    y: 6.5,
    width: 14,
    height: 8
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAspectRatio);
export default __webpack_public_path__ + "static/media/icon-aspect-ratio.724f845601fa37f5bb1c621bd0026325.svg";
export { ForwardRef as ReactComponent };